var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.libro !== null || _vm.libro !== undefined)?_c('div',{staticClass:"text-left text-dark col"},[_c('FormularioLibro',{attrs:{"firebase":_vm.firebase,"libro":_vm.libro,"editar":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }